import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MatDialog } from "@angular/material/dialog";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "../services/common.service";
import { RuleConfigComponentComponent } from "../rule-config-component/rule-config-component.component";
import { Routeversion1Component } from "../routeversion1/routeversion1.component";
import { Subject, Subscription } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import beautify from "xml-beautifier";
import * as XLSX from 'xlsx';
import { DataParserService } from "../services/data-parser.service";
import {
  flattenXmlFieldKeyMapDocument
} from "../routing-ruleconfig1/xml/xml-field-key-map.flatten";
import {
  xmlFieldOptionDisplayLabel,
  type XmlFieldOption
} from "../routing-ruleconfig1/models/field-option.model";
import xmlFieldKeyMapRaw from "../../assets/rule-config/field-key-map-xml.json";
declare var $

declare const copyToClipboard: any;

const GUID_PATTERN =
  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

/** One route row in Search Builder results grid. */
interface SearchBuilderRouteItem {
  id: string;
  displayname: string;
  vendorName?: string;
  vendorId?: string;
  sourceEntityId?: string;
  sourceEntityName?: string;
  destinationEntityId?: string;
  destinationEntityName?: string;
  messageType?: string;
  status?: string;
  processorId?: string;
  processorName?: string;
  uniqueId?: number;
  version?: string;
  setype?: string;
  detype?: string;
  ruleMatchStatus?: string;
}

/** Same shape as Rule Config create-rules row (Validation stage). */
/** One advanced filter row in Search Builder (field, operator, value). */
interface SearchBuilderAdvancedRule {
  field: string;
  operator: string;
  value: string;
}

/** Field label + XPath option for Search Builder advanced filter dropdown. */
interface SearchBuilderRuleFieldOption {
  label: string;
  path: string;
}

@Component({
  selector: 'app-rule-engine-try-it-out',
  templateUrl: './rule-engine-try-it-out.component.html',
  styleUrls: ['./rule-engine-try-it-out.component.scss']
})
export class RuleEngineTryItOutComponent implements OnInit, OnDestroy {
    selectedrouteIdgblGqr: string = ''; 
  
      inputdata: any;
      pdfviwerflag: boolean=false;
      OutputData: string = "";
      formatType: string = "text/plain";
      defaultFormatType:string='text/plain';
      defaultFormatTypeGqr:string='text/plain';
      previewDataXMl: boolean = false;
      public reactiveFormdeployment: FormGroup;
      deploymentItemsList = [];
      deploymentSelected: string = '';
  
      editorOptions = {
          theme: 'vs', language: this.defaultFormatType, wordWrap: 'on',scrollBeyondLastLine: false
      };
  
      editorOptions1 = {theme: 'vs', language: this.defaultFormatType,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false
      };

      editorOptionsGqr = {
        theme: 'vs', language: this.defaultFormatTypeGqr, wordWrap: 'on',scrollBeyondLastLine: false,automaticLayout: true 

    };

    editorOptionsGqr1 = {theme: 'vs', language: this.defaultFormatTypeGqr,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false
    };
      reactiveFormroutegbl: FormGroup;
      reactiveFormroutegblGqr: FormGroup;
      onvaluechange: Subject<string> = new Subject<string>();
      inputdatabackupdata: string;
      fileName: string;
    selectedrouteDisplayNamegblGqr: any;
    isLoadingroutesGqr: boolean = false;
routedetailsGqr: any;
notfounddataGqr: any;
reactiveFormagent: FormGroup;
isLoadingagent: boolean = false;
 AgentNameList: any[];
 selectedAgentguid: any;
    selectedAgentName: any;
    AgentDetailsList: any[];
    agenttype: string;
    agentstatusvalue: string;
    agentmodevalue: string;
    selectedrouteuniqueid: any;
    agentmodelist: any;
    agentstagelist: any;
    public reactiveFormmsgtype: FormGroup;
    isLoadingmessagetype: boolean = false;
    
    messageTypeList: any = [];
    messageTypeAllList: any = [];
    qualifiedRoutesList: { id: string; displayname: string }[] = [];
    searchBuilderRoutesList: SearchBuilderRouteItem[] = [];
    searchBuilderRoutesListAll: SearchBuilderRouteItem[] = [];
    showSearchBuilderAdvancedFilter = false;
    searchBuilderAdvancedRules: SearchBuilderAdvancedRule[] = [
      { field: "", operator: "", value: "" }
    ];
    searchBuilderRuleFieldOptions: SearchBuilderRuleFieldOption[] = [];
    private searchBuilderRuleFieldDisplayToPath = new Map<string, string>();
    private searchBuilderFieldPathsSub?: Subscription;
    searchBuilderTotalRecords = 0;
    searchBuilderPageNumber = 1;
    searchBuilderPageSize = 15;
    searchBuilderIncludePassiveRoutes = false;
    searchBuilderSearched = false;
    searchBuilderLastSearchUsedAdvancedRules = false;
    @ViewChild('searchBuilderPaginator', { static: false }) searchBuilderPaginator!: MatPaginator;
    reactiveFormSbLab: FormGroup;
    reactiveFormSbFacility: FormGroup;
    reactiveFormSbMsgtype: FormGroup;
    reactiveFormGqrEntity: FormGroup;
    reactiveFormGqrAccession: FormGroup;
    gqrSearchkey: string = '';
    gqrEntityList: any[] = [];
    isLoadingGqrEntity = false;
    notfounddataGqrEntity = false;
    gqrEntityLocationGUID = '';
    gqrEntityTypeName = '';
    gqrEntityDeploymentKey = '';
    searchBuilderLabList: any[] = [];
    searchBuilderFacilityList: any[] = [];
    isLoadingSbLab = false;
    isLoadingSbFacility = false;
    notfounddataSbLab = false;
    notfounddataSbFacility = false;
    keywordsearchEntity = 'LocationName';
    sbLabLocationGUID = '';
    sbLabDeploymentKey = '';
    sbLabAssociatedAccountIds = '';
    sbLabTypeName = '';
    sbFacilityLocationGUID = '';
    sbFacilityDeploymentKey = '';
    sbFacilityAssociatedAccountIds = '';
    sbFacilityTypeName = '';
    searchBuilderMessageType = '';
  
      constructor(
        private _formBuilder: FormBuilder,
        private ngxUiLoaderService: NgxUiLoaderService,
        public service: CommonService,
        private _fb: FormBuilder,
        public activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private toastr: ToastrService,
        private commonService: CommonService,
        private dialog: MatDialog,
        private viewContainerRef: ViewContainerRef,
        private dataParserService: DataParserService
      ) {
          
          this.reactiveFormroutegbl = _fb.group({ routenamegbl: '' });
          this.reactiveFormroutegblGqr = _fb.group({ routenamegblGqr: '' });
          this.reactiveFormagent = _fb.group({ agentname: '' });
          this.reactiveFormmsgtype = this._fb.group({ msgname: '' });
          //this.deploymentSelected=this.deploymentItemsList.find(V=>V.toLowerCase()==obj.dkey.toLowerCase());
          
          this.reactiveFormdeployment = this._formBuilder.group({ deploymentname: ['', Validators.required] });
          this.reactiveFormSbLab = _fb.group({ labname: '' });
          this.reactiveFormSbFacility = _fb.group({ facilityname: '' });
          this.reactiveFormSbMsgtype = _fb.group({ msgname: '' });
          this.reactiveFormGqrEntity = _fb.group({ entityname: '' });
          this.reactiveFormGqrAccession = _fb.group({ accessionname: '' });
      }
      screeHeightforoutput: number;
      screeHeightforinput: number;
      screeHeightforinputGqr: number;
      enableAccessionSearch: boolean = false;
      fileUploadFTP: boolean;
      routedetails: {
          RouteIdtry: any;
          ProcessorIdtry: any;
          ProcessorDisplayNametry: any;
          RouteDisplayNametry: any;
          Processorapikey: any;
          Popupflag: boolean;
          MappedXmlTemp: string;
          isFileUpload: boolean;
          isfiledownload: boolean;
          interfacetype: any;
          enableAccessionSearch: boolean;
          fileUploadFTP: boolean;
          sourcedeploymentkey: any;
          targetdeploymentkey: any;
          sourceaccounttype: any;
          targetaccounttype: any;
          seguid: any;
          deguid: any;
          sourceagent: any
      };
      versionDetails: any[];
      versionList: string[] = [];
      version: any;
      notfounddata: boolean;
     
      backupfileArray: any[]=[];
      routeMessageType:any;
      uniqueid: any;
      isValidationFlag:boolean;
      routeUniqueID: any;
      connectivitytype:string='';
      fileContent: string;
      inputdataGqr: any;
      editorInit(editor) {
          if(editor!==undefined && editor!==''){
                  if (this.inputdata) {
                      if (this.inputdata.byteLength > 0) {
                          if (this.OutputData.trim().startsWith("<")) {
                              this.formatType = "xml";
                          } else if (this.OutputData.trim().startsWith("{")) {
                              this.formatType = "json";
                          }
                      }
                      else if (this.inputdata.trim().startsWith("<") || this.OutputData.trim().startsWith("<")) {
                          this.formatType = "xml";
                      } else if (this.inputdata.trim().startsWith("{") || this.OutputData.trim().startsWith("{")) {
                          this.formatType = "json";
                      }
                  }
              if(this.defaultFormatType!=this.formatType){
                  this.defaultFormatType=this.formatType;
                  this.editorOptions = {
                      ...this.editorOptions,
                      language: this.formatType
                  };
                  this.editorOptions1 = {
                      ...this.editorOptions1,
                      language: this.formatType,
                      readOnly:true
                  };
              }
              }
      }
  
      editorInitGqr(editor) {
        if(editor!==undefined && editor!==''){
                if (this.inputdataGqr) {
                    if (this.inputdataGqr.byteLength > 0) {
                        if (this.OutputData.trim().startsWith("<")) {
                            this.formatType = "xml";
                        } else if (this.OutputData.trim().startsWith("{")) {
                            this.formatType = "json";
                        }
                    }
                    else if (this.inputdataGqr.trim().startsWith("<") || this.OutputData.trim().startsWith("<")) {
                        this.formatType = "xml";
                    } else if (this.inputdataGqr.trim().startsWith("{") || this.OutputData.trim().startsWith("{")) {
                        this.formatType = "json";
                    }
                }
            if(this.defaultFormatTypeGqr!=this.formatType){
                this.defaultFormatTypeGqr=this.formatType;
                this.editorOptionsGqr = {
                    ...this.editorOptionsGqr,
                    language: this.formatType
                };
                this.editorOptionsGqr1 = {
                    ...this.editorOptionsGqr1,
                    language: this.formatType,
                    readOnly:true
                };
            }
            }
    }

    onTabChange(event: any): void {
        if (event.index === 1) { 
          setTimeout(() => {
            this.screeHeightforinputGqr = window.innerHeight - 281; 
          }, 100);
        }
      }
      registerMonacoCustomTheme() {
          monaco.editor.defineTheme("myCustomTheme", {
              base: "vs", 
              inherit: true, 
              rules: [
                  {
                      token: "comment",
                      foreground: "ffa500",
                      fontStyle: "italic underline"
                  }, {
                      token: "comment.js",
                      foreground: "008800",
                      fontStyle: "bold"
                  }, {
                      token: "comment.css",
                      foreground: "0000ff"
                  }, 
              ],
              colors: {}
          });
      }
  
      RouteIdtry: string;
      ProcessorIdtry: string;
      classObjalert: string;
      StatusMessage: string;
     
      statusmessagetryitout: boolean = false;
      Processorapikey: string;
      IsFileUpload: boolean = false;
      IsFileDownload: boolean = false;
      popupflag: boolean = true;
      MappedXmlTemp: string;
      filecheck: boolean;
      
      fileidValue: string;
      sourceaccounttype: string = "";
      targetaccounttype: string = "";
      seguid: string = "";
      deguid: string = "";
      ngoniniteditorcall:any;
      flag=false;
      ngOnInit() {
        this.getDeployments();
        this.reactiveFormdeployment.patchValue({ "deploymentname": this.deploymentSelected });
        this.getMessagetypelist('msgtype');
        this.initSearchBuilderRuleFieldOptions();
          this.screeHeightforoutput = window.innerHeight - 210;
          this.screeHeightforinput = window.innerHeight - 281;
          this.screeHeightforinputGqr= window.innerHeight - 281;
    
              this.fileUploadFTP = false;
              this.enableAccessionSearch = false;
           
              this.popupflag = false;
              this.MappedXmlTemp = "";
            
          this.flag=true;
      }

      ngOnDestroy(): void {
        this.searchBuilderFieldPathsSub?.unsubscribe();
      }

      /** Load user-friendly field labels from routing rule config, while keeping xpath for search. */
      // ---------- Search Builder: advanced filter (field / operator / value) ----------

      /** Loads user-friendly field labels and XPath paths from field-key-map-xml.json for advanced filter dropdown. */
      private initSearchBuilderRuleFieldOptions(): void {
        this.dataParserService.resetTemplateParserState();
        this.searchBuilderFieldPathsSub?.unsubscribe();
        const flat = flattenXmlFieldKeyMapDocument(xmlFieldKeyMapRaw);
        const byPath = new Map<string, SearchBuilderRuleFieldOption>();
        this.searchBuilderRuleFieldDisplayToPath.clear();

        Object.entries(flat).forEach(([mapKey, raw]) => {
          const key = (mapKey || '').trim();
          if (!key) {
            return;
          }
          const meta =
            typeof raw === 'string'
              ? { path: raw }
              : { ...raw };
          const path = (meta.path || '').trim();
          if (!path) {
            return;
          }
          const displayKey = (meta.displayKey || '').trim() || key;
          const label = xmlFieldOptionDisplayLabel({
            key,
            label: displayKey,
            listLabel: displayKey !== key ? key : undefined,
            path,
            leaf: path.split('/').pop() || ''
          } as XmlFieldOption);
          const option = { label, path };
          if (!byPath.has(path)) {
            byPath.set(path, option);
          }
          this.searchBuilderRuleFieldDisplayToPath.set(label, path);
          this.searchBuilderRuleFieldDisplayToPath.set(key, path);
        });

        this.searchBuilderRuleFieldOptions = Array.from(byPath.values()).sort((a, b) =>
          a.label.localeCompare(b.label)
        );
      }

      /** Shows or hides the advanced filter panel below the Search Builder filter bar. */
      toggleSearchBuilderAdvancedFilter(): void {
        this.showSearchBuilderAdvancedFilter = !this.showSearchBuilderAdvancedFilter;
      }

      /** Adds a blank advanced rule row (field, IN/NOT IN, value). */
      addSearchBuilderAdvancedRule(): void {
        this.searchBuilderAdvancedRules.push({
          field: "",
          operator: "",
          value: ""
        });
      }

      /** Removes an advanced rule row; keeps at least one empty row. */
      removeSearchBuilderAdvancedRule(index: number): void {
        if (this.searchBuilderAdvancedRules.length <= 1) {
          this.searchBuilderAdvancedRules[0] = {
            field: "",
            operator: "",
            value: ""
          };
          return;
        }
        this.searchBuilderAdvancedRules.splice(index, 1);
      }

      /** Resets advanced rules to a single empty row. */
      clearSearchBuilderAdvancedRules(): void {
        this.searchBuilderAdvancedRules = [
          { field: "", operator: "", value: "" }
        ];
      }

      /** True when every advanced rule row is empty or has field, operator, and value. */
      private isSearchBuilderAdvancedFilterValid(): boolean {
        return this.searchBuilderAdvancedRules.every((rule) => {
          const field = (rule.field || '').trim();
          const operator = (rule.operator || '').trim();
          const hasValue = (rule.value ?? '').length > 0;
          const anyFilled = !!(field || operator || hasValue);
          return !anyFilled || !!(field && operator && hasValue);
        });
      }

      /** Disables Search only while advanced filter panel is open with incomplete rows. */
      canSearchBuilderSearch(): boolean {
        if (this.showSearchBuilderAdvancedFilter && !this.isSearchBuilderAdvancedFilterValid()) {
          return false;
        }
        return true;
      }

      /** Returns completed advanced rules with display labels resolved to XPath paths for the API. */
      private getActiveSearchBuilderAdvancedRules(): SearchBuilderAdvancedRule[] {
        return this.searchBuilderAdvancedRules.map((r) => ({
          ...r,
          field: this.resolveSearchBuilderAdvancedFieldPath(r.field)
        })).filter((r) => {
          const field = (r.field || "").trim();
          const operator = (r.operator || "").trim();
          if (!field || !operator) {
            return false;
          }
          return (r.value ?? '').length > 0;
        });
      }

      /** Maps a friendly field label to its RuleConfig XPath (or returns raw path if already an XPath). */
      private resolveSearchBuilderAdvancedFieldPath(field: string): string {
        const raw = (field || '').trim();
        if (!raw) {
          return '';
        }
        return this.searchBuilderRuleFieldDisplayToPath.get(raw) || raw;
      }

      /** Public wrapper for template: returns XPath for an advanced filter field label. */
      getSearchBuilderAdvancedFieldPath(field: string): string {
        return this.resolveSearchBuilderAdvancedFieldPath(field);
      }

      isValuefromInput: boolean = false;

      getstringRoute(value) {
          let names = value.split("(")
          value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
          return value
      }
      searchkey: string = "";
      GetxmlByAccessionNumber() {
          this.inputdata = "";
          this.OutputData = "";
          if (this.searchkey) {
  
              let isvalid = false;
              if (this.searchkey.indexOf(',') > -1) {
                  //isvalid = true;
                  this.toastr.warning("Multiple Accession Search is not supported!", "", {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
              });
              
              }
              else if (this.searchkey.split(',').length <= 5) {
                  isvalid = true;
              }
              if (isvalid) {
                  let dpkey = "";
                  
                  //this condition is added as XML is not getting populated if SE is defaultEntity for the route
                  if (this.routedetails.seguid.toLowerCase() == "defaultentity") {
                    this.toastr.warning("Unable to get XML as SE is Default Entity for the route", "", {
                      timeOut: 4000,
                      positionClass: 'toast-bottom-right'
                    });
                    return false;
                  }

                  if ( (this.routedetails != undefined && (this.routedetails.interfacetype === "Outbound" || this.routedetails.interfacetype === "EllkayResultOutbound"))) 
                      dpkey =  this.routedetails.sourcedeploymentkey ;
               
  
                  this.ngxUiLoaderService.start();
                  var apiname = "api/CoreConfig/GetProcessorUIConfig?agentid=&apikey=";
                  this.service.getapi(apiname).then(responseconfig => {
                      ;
                      var configs = JSON.parse(responseconfig.responsebody);
                      var dpconfig = configs[dpkey];
                     
                      var searchData = {
                          "id":  this.routedetails.ProcessorIdtry ,
                          "type": "Processor"
                      };
                      var messagetype = "";
                      var apiname = 'api/Agents/GetSearchDetails';
                      this.service.searchpostapi(apiname, searchData).then(responseagent => {
                          const resultset = responseagent as any[];
                          var processoragentconfigdata;
                          if (resultset[0]["jsonconfig"]) {
                              var jsonconfig = JSON.parse(resultset[0]["jsonconfig"]);
                              processoragentconfigdata = jsonconfig.processoragentconfig;
                              if (processoragentconfigdata != undefined) {
                                  if (processoragentconfigdata.messagetype) {
                                      messagetype = processoragentconfigdata.messagetype;
                                  }
                              }
                          }
                          if (messagetype.toLowerCase() == 'result') {
                              messagetype = "Results";
                          } else if (messagetype.toLowerCase() == 'order') {
                              messagetype = "Orders";
                          }
                          var EntityType = '';
                          var EntityValue = '';
                          let isEmptyAccounttype = false;
                          if (this.routedetails && this.routedetails.targetaccounttype == "") {
                              this.ngxUiLoaderService.stop();
                              this.toastr.error("Account type of the Destination entity is not available", "", {
                                  timeOut: 4000,
                                  positionClass: 'toast-bottom-right'
                              });
                              isEmptyAccounttype = true;
                          }
                          if (!isEmptyAccounttype) {
                            this.ngxUiLoaderService.start();
                              if ( this.routedetails != undefined && (this.routedetails.interfacetype === "Outbound" || this.routedetails.interfacetype === "EllkayResultOutbound")) {
                                  EntityType = this.routedetails.sourceaccounttype ;
                                  EntityValue =  this.routedetails.seguid ;
                              } 
                              
                              var inputsearch = {
                                  "AccessionnumberList": this.searchkey.split(','),
                                  "EntityType": EntityType,
                                  "EntityValue": EntityValue,
                                  "MessageType": messagetype,
                                  "Headers": JSON.stringify(dpconfig.apidetails["headers"]),
                                  "Url": dpconfig.apidetails["inputxmlapiurl"]
                              }
                              this.getcasexml(inputsearch);
  
                          }
                      });
                  });
  
              }
             
          }
          else {
              this.toastr.warning("Please enter the accession number!!", "", {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
              });
          }
  
      }
      inputxml = [];
      getcasexml(input) {
          this.inputxml = [];
          let counter = 0;
          for (let i = 0; i < input.AccessionnumberList.length; i++) {
  
              let obj = {
                  "Accessionnumber": input.AccessionnumberList[i],
                  "EntityType": input.EntityType,
                  "EntityValue": input.EntityValue,
                  "MessageType": input.MessageType,
                  "Headers": input.Headers,
                  "Url": input.Url
              }
              this.service.postapi("api/TransformXml/GetInputXML", obj).then(dxresponse => {
  
                  if (!dxresponse || !dxresponse['responsemessage']) {
                      this.ngxUiLoaderService.stop();
                      this.toastr.warning("No data found", "", {
                          timeOut: 4000,
                          positionClass: 'toast-bottom-right'
                          });
                      
                  }
                  else if (!dxresponse['xml'] && dxresponse['responsemessage']) {
                      this.ngxUiLoaderService.stop();
                      this.inputdata = dxresponse['responsemessage'];
                  }
                  else if (dxresponse['responsemessage'] && dxresponse['xml']) {
  
                          this.inputdata = dxresponse["xml"];
                          //this.searchkey = "";
                          this.ngxUiLoaderService.stop();
                      
                  } else {
                      this.ngxUiLoaderService.stop();
                      this.toastr.warning("Not data found", "", {
                              timeOut: 4000,
                              positionClass: 'toast-bottom-right'
                          });
                      this.searchkey = "";
                  }                
              });
  
          }
  
      }
     
  
     
      clearAll() {
          this.classObjalert = "col-sm-5";
          this.OutputData = "";
          this.StatusMessage = "";
          
          this.previewDataXMl = false;
          this.fileidValue = "";
          
          this.filecheck = false;
          this.notfounddata = false;
          this.notfounddataGqr = false;
       
          this.searchkey='';
          this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
      }

       // Clear all for ValidateRule
  clearAllValidateRule(): void {
    this.inputdata = ''; 
    this.reactiveFormroutegbl.reset(); 
    this.selectedrouteIdgbl = ''; 
    this.selectedrouteDisplayNamegbl = ''; 
    this.validationStatusMessage = ''; 
    this.clearAll();
    this.searchRouteNameClearedgbl(null);
  }

  // Clear all for GetQualifiedRoutes
  clearAllGetQualifiedRoutes(): void {
    this.inputdataGqr = '';
    this.gqrSearchkey = '';
    this.reactiveFormGqrAccession.reset();
    this.gqrEntityCleared();
    this.reactiveFormagent.reset();
    this.reactiveFormmsgtype.reset();
    this.selectedAgentguid = '';
    this.selectedmessagetype = '';
    this.qualifiedRoutesList = [];
    this.clearAll();
    this.Clearemessagetype(null);
  }

  // Check if there's input for Validate Rule tab
  hasInputForValidateRule(): boolean {
    return this.inputdata && this.inputdata.toString().trim().length > 0;
  }

  // Check if there's input for Qualified Routes tab
  hasInputForQualifiedRoutes(): boolean {
    const hasXml =
      this.inputdataGqr && this.inputdataGqr.toString().trim().length > 0;
    const hasAccession = !!(this.gqrSearchkey && this.gqrSearchkey.trim());
    const hasEntity = !!this.gqrEntityLocationGUID;
    return hasXml || hasAccession || hasEntity;
  }
  
      copyToClip(event: any, message: any) {
          if (event != "") {
              var xmlDocument;
              try {
                  xmlDocument = (new DOMParser()).parseFromString(event, 'text/xml');
              }
              catch {
                  xmlDocument = "";
              }
              if (xmlDocument) {
                  event = beautify(event);
              }
              copyToClipboard(event);
             
              this.toastr.success(message + " Copied", "", {
                  timeOut: 500,
                  positionClass: 'toast-bottom-right'
              });
          }
      }

      /** Keyboard accessibility for route row: Enter/Space opens Pipeline Rules dialog. */
      onSearchBuilderRouteRowKeydown(event: KeyboardEvent, route: any): void {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        event.preventDefault();
        this.onSearchBuilderRouteRowClick(route);
      }
  
      isLoadingroutes: boolean = false;
      RouteNameListgbl: any = [];
      //RouteNameListgblGqr: any[] = [];
      selectedrouteIdgbl: string = '';
      selectedrouteDisplayNamegbl: string = '';
      keywordsearchgbl: string = 'displayname';
      keywordsearchgblGqr: string = '';
      keywordsearch = "displayname";
  
      getRouteNamegbl(event: any) {
          var val = event;
          if (val) {
              this.isLoadingroutes = true;
              var apiname = "api/Routes/GetByDisplayName?name=" + val + "&version=0";
              this.service.getapiurl(apiname).subscribe({
                  next: data => {
                      this.RouteNameListgbl = data as any[];
                      this.RouteNameListgbl.map(
                          obj => obj.displayname = `${obj.displayname
                              } ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'
                              }`
                      );
                      //console.log('RouteNameListgbl:', this.RouteNameListgbl);
                      this.isLoadingroutes = false;
                      if (data.length == 0) {
                          this.notfounddata = true;
                      }
                      else {
                          this.notfounddata = false;
                      }
                  },
                  error: error => {
                      this.isLoadingroutes = false;
                      this.notfounddata = true;
                  }
              });
          }
  
      }
  
   
  
      selectedRoutegbl(item) {
          this.selectedrouteIdgbl = item.id;
          this.selectedrouteDisplayNamegbl = item.displayname;
          this.getRouteDetails();
      }

     

      searchRouteNameClearedgbl(event) {
          this.isLoadingroutes = false;
          this.RouteNameListgbl = [];
          this.selectedrouteIdgbl = '';
          this.selectedrouteDisplayNamegbl = '';
          this.fileUploadFTP = false;
          this.enableAccessionSearch = false;
          this.notfounddataGqr = false;
          this.filecheck = false;
          this.fileidValue = "";
          //this.notfounddata = false;
          this.routedetails = {
              RouteIdtry: "",
              ProcessorIdtry: "",
              ProcessorDisplayNametry: "",
              RouteDisplayNametry: "",
              Processorapikey: "",
              Popupflag: false,
              MappedXmlTemp: "",
              isFileUpload: false,
              isfiledownload: false,
              interfacetype: "",
              enableAccessionSearch: false,
              fileUploadFTP: false,
              sourcedeploymentkey: "",
              targetdeploymentkey: "",
              sourceaccounttype: "",
              targetaccounttype: "",
              seguid: "",
              deguid: "",
              sourceagent: ""
          }
      }

   
  
  
      async getRouteDetails() {
          this.inputdata = "";
          this.searchkey = "";
          this.OutputData = "";
          if (this.selectedrouteIdgbl != "") {
              var url = "api/Routes/GetRouteList?id=" + this.selectedrouteIdgbl;
              this.ngxUiLoaderService.start();
              this.service.getapiurl(url).subscribe({
                  next: async (data) => {
                      this.routeMessageType=data["messagetype"];
                      this.routeUniqueID=data["UniqueID"];
                      this.connectivitytype = data['Connectivity'];
                      let response = await this.getFileConfig(data["id"], data["PAID"]);
                      if (response.length>0 && response[0]["json"] != '' && response[0]["json"] != null) {
                          var jsonData;
                          var vaconfigdata;
                          var interfacetype = "";
                          if (response[0]["json"] != '' && response[0]["json"] != null) {
                              jsonData = JSON.parse(response[0]["json"]);
  
                              if (jsonData.processorconfig != undefined && jsonData.processorconfig["vaconfig"] != undefined) {
                                  vaconfigdata = jsonData.processorconfig["vaconfig"];
                              }
                              if (jsonData.processorconfig != undefined && jsonData.processorconfig["interfacetype"] != undefined) {
                                  interfacetype = jsonData.processorconfig["interfacetype"];
                              }
                          }
                          this.isValuefromInput = false;
                          if (data["INTERFACETYPE"] === "Inbound" || data["INTERFACETYPE"] === "EllkayInbound") {
                              this.fileUploadFTP = true;
                              this.enableAccessionSearch = false;
                          } else if (data["INTERFACETYPE"] === "Outbound" || data["INTERFACETYPE"] === "EllkayOutbound") {
                              this.fileUploadFTP = false;
                              this.enableAccessionSearch = true;
                          }
                          else {
                              this.fileUploadFTP = false;
                              this.enableAccessionSearch = false;
                          }
                          if (this.enableAccessionSearch || this.fileUploadFTP) {
                              this.screeHeightforinput = window.innerHeight - 288;
                          }
  
                          let isfileupload = 0;
                          let isfiledownload = 0;
                          if (vaconfigdata != undefined) {
                              isfileupload = vaconfigdata.isfileupload;
                          }
  
                          if (vaconfigdata != undefined) {
                              isfiledownload = vaconfigdata.isfiledownload;
                          }
  
                          this.routedetails = {
                              RouteIdtry: data["id"],
                              ProcessorIdtry: data["PAID"],
                              ProcessorDisplayNametry: data["PANAME"],
                              RouteDisplayNametry: data["displayname"],
                              Processorapikey: data["PAAPIKEY"],
                              Popupflag: true,
                              MappedXmlTemp: "",
                              isFileUpload: isfileupload == 0 ? false : true,
                              isfiledownload: isfiledownload == 0 ? false : true,
                              interfacetype: interfacetype,
                              enableAccessionSearch: this.enableAccessionSearch,
                              fileUploadFTP: this.fileUploadFTP,
                              sourcedeploymentkey: data["SEDEPLOYMENTKEY"],
                              targetdeploymentkey: data["DEDEPLOYMENTKEY"],
                              sourceaccounttype: data["sourcetype"],
                              targetaccounttype: data["targettype"],
                              seguid: data["SEGUID"],
                              deguid: data["DEGUID"],
                              sourceagent: data["sourceagentid"]
                          };
                          this.ngxUiLoaderService.stop();
                          
                      }
                      else {
  
                          this.ngxUiLoaderService.stop();
                          this.toastr.warning("Please check the Pipeline configurations", "", {
                              timeOut: 4000,
                              positionClass: 'toast-bottom-right'
                          });
                          
                      }
  
                  },
                  error: error => {
                      this.ngxUiLoaderService.stop();
                  }
              });
          }
      }
      async getFileConfig(routeid: string, ProcessorId: string) {
          var dataPost = {
              agentid: ProcessorId,
              guids: routeid
          };
  
          return await this.service.postapi("api/CoreConfig/GetCoreConfig", dataPost);
  
          //
      }

      isValidXML(xml: string): boolean {
        try {
          const parser = new DOMParser();
          const parsedXml = parser.parseFromString(xml, "text/xml");
          const parserError = parsedXml.getElementsByTagName("parsererror");
          return parserError.length === 0; // If no parser errors, it's valid XML
        } catch (error) {
          return false; 
        }
      }
      
      overallCheck: boolean = false;
      ruleValidationResponse: any;
      validationStatusMessage: string = '';

      validateRule() {
        if (!this.inputdata) {
          this.toastr.warning("Input data is required", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return;
        }

        if (!this.routedetails?.RouteIdtry) {
          this.toastr.warning("Pipeline is required", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return;
        }

         // Validate if inputdataGqr is valid XML
    if (!this.isValidXML(this.inputdata)) {
        this.toastr.error("Input should be in XML format", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return;
      }
        const requestBody = {
          xml: this.inputdata,
          routeid: this.routedetails.RouteIdtry
        };

        this.ngxUiLoaderService.start();
        this.commonService.validateRule(requestBody).subscribe(
          (response: any) => {
            this.ngxUiLoaderService.stop();
            if (response) {
              try {
                const responsebody = JSON.parse(response.responsebody);
                this.overallCheck = responsebody.OverAllCheck;
                this.ruleValidationResponse = responsebody;
                if(response.status==="Eventype Configured")
                    {
                        this.toastr.error("Eventype Configured", "Rule validation failed", {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.validationStatusMessage = 'Rule validation failed as eventype is configured in rule';
                    }
                else{
                if (this.overallCheck) {
                  this.toastr.success("Rule validation successful", "", {
                    timeOut: 500,
                    positionClass: 'toast-bottom-right'
                  });
                  this.validationStatusMessage = JSON.parse(response.responsebody);
                } else {
                  this.validationStatusMessage = JSON.parse(response.responsebody);
                  this.toastr.error("Rule validation failed", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                  });
                }
            }
              } catch (error) {
                this.toastr.error("Error parsing validation response", "", {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
                });
              }
            }
          },
          (error) => {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Error validating rules", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        );
      }

      
      

      selectedmessagetype: string = '';
  selectedmessagetypeevent(item) {
    this.selectedmessagetype = item.displayname;
  }
  
 getMessagetypelist(event) {
    const val = event;
    if(val)
    {
    this.isLoadingmessagetype = true;
      this.service.getapiurl("api/Lookup/GetMessageType?lookuptype=messagetype").subscribe({
        next: data => {
          this.messageTypeAllList = [];
          data.forEach(element => {
            this.messageTypeAllList.push({ displayname: element });
          });
          this.messageTypeList = this.messageTypeAllList;

          this.isLoadingmessagetype = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingmessagetype = false;
          this.notfounddata = true;
        }
      });
    }
  }
  
  Clearemessagetype(event) {
    this.selectedmessagetype = '';
    // this.messageTypeList = this.messageTypeAllList;
    this.messageTypeList = [];
    this.messageTypeList = this.messageTypeAllList;
  }

  // ---------- Qualified Routes: entity autocomplete (GetAccountNames) ----------

  onGqrAccessionInput(value: string): void {
    this.gqrSearchkey = (value ?? '').toString();
    this.reactiveFormGqrAccession.patchValue({ accessionname: value });
  }

  gqrAccessionCleared(): void {
    this.gqrSearchkey = '';
    this.reactiveFormGqrAccession.reset();
  }

  selectedGqrEntity(item: any): void {
    if (!item) {
      return;
    }
    this.gqrEntityLocationGUID = item.LocationGUID || '';
    this.gqrEntityDeploymentKey = item.deploymentkey || '';
    this.gqrEntityTypeName = this.resolveEntityTypeName(item.TypeName, item.Type);
  }

  gqrEntityCleared(): void {
    this.isLoadingGqrEntity = false;
    this.gqrEntityList = [];
    this.gqrEntityLocationGUID = '';
    this.gqrEntityDeploymentKey = '';
    this.gqrEntityTypeName = '';
    this.notfounddataGqrEntity = false;
    this.reactiveFormGqrEntity.reset();
  }

  getGqrEntityNames(event: string): void {
    const valuesa = this.normalizeEntitySearchInput(event);
    const typedGuid = this.extractGuidFromText(event);
    this.gqrEntityDeploymentKey = '';
    this.gqrEntityTypeName = '';
    this.gqrEntityLocationGUID = typedGuid || '';
    this.reactiveFormGqrEntity.patchValue({ entityname: event });
    if (valuesa !== '' && !valuesa.endsWith(':') && !valuesa.endsWith(': ')) {
      const valueToSendToApi = valuesa.split(': ').join(':');
      this.isLoadingGqrEntity = true;
      this.fetchGqrEntityNames(valueToSendToApi, typedGuid, () => {
        this.isLoadingGqrEntity = false;
      });
    } else {
      this.gqrEntityList = [];
      this.notfounddataGqrEntity = !typedGuid;
    }
  }

  private fetchGqrEntityNames(
    searchText: string,
    typedGuid: string,
    onComplete: () => void
  ): void {
    this.service
      .GetAccountNamesListAsync({ lsearch: searchText, lSearch: searchText })
      .subscribe({
        next: (response: any) => {
          const hasResults = Array.isArray(response) && response.length > 0;
          if (!hasResults && typedGuid) {
            this.service.getEntityfilterdata(typedGuid).subscribe({
              next: (fallback: any) => {
                this.handleGqrEntityResponse(fallback, typedGuid, onComplete);
              },
              error: () => {
                this.handleGqrEntityResponse(response, typedGuid, onComplete);
              },
            });
            return;
          }
          this.handleGqrEntityResponse(response, typedGuid, onComplete);
        },
        error: () => {
          this.gqrEntityList = [];
          this.notfounddataGqrEntity = true;
          onComplete();
        },
      });
  }

  private handleGqrEntityResponse(
    response: any,
    typedGuid: string,
    onComplete: () => void
  ): void {
    if (response?.status && response?.statusText) {
      this.gqrEntityList = [];
      this.notfounddataGqrEntity = !typedGuid;
      onComplete();
      this.toastr.error('Unable to fetch entity details', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    if (Array.isArray(response) && response.length > 0) {
      const list = this.formatSearchBuilderEntityList(response);
      this.gqrEntityList = list;
      this.notfounddataGqrEntity = false;

      // if (typedGuid) {
      //   const match = this.findSearchBuilderEntityMatch(list, typedGuid);
      //   if (match) {
      //     this.selectedGqrEntity(match);
      //     this.reactiveFormGqrEntity.patchValue(
      //       { entityname: match.LocationName },
      //       { emitEvent: false }
      //     );
      //   }
      // }
    } else {
      this.gqrEntityList = [];
      this.notfounddataGqrEntity = !typedGuid;
    }
    onComplete();
  }

  private normalizeGqrMessageType(messageType: string): string {
    const val = (messageType || '').toLowerCase();
    if (val === 'result') {
      return 'Results';
    }
    if (val === 'order') {
      return 'Orders';
    }
    return messageType;
  }

  private mapGqrEntityTypeForApi(entityType: string): string {
    const val = (entityType || '').trim().toLowerCase();
    if (val === 'organization' || val === 'o') {
      return 'organization';
    }
    if (val === 'account' || val === 'a') {
      return 'account';
    }
    return entityType;
  }

  private async getGqrCaseXml(): Promise<string | null> {
    const accession = (this.gqrSearchkey || '').trim();
    if (!accession) {
      return null;
    }

    if (!this.gqrEntityLocationGUID || !this.gqrEntityTypeName) {
      this.toastr.warning(
        'Entity is required when accession number is provided',
        '',
        {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        }
      );
      return null;
    }

    if (!this.deploymentSelected) {
      this.toastr.warning('Deployment is required', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return null;
    }

    if (!this.selectedmessagetype) {
      this.toastr.warning('Message Type is required', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return null;
    }

    this.ngxUiLoaderService.start();
    try {
      const responseconfig = await this.service.getapi(
        'api/CoreConfig/GetProcessorUIConfig?agentid=&apikey='
      );
      const configs = JSON.parse(responseconfig.responsebody);
      const dpconfig = configs[this.deploymentSelected];
      if (!dpconfig?.apidetails?.inputxmlapiurl) {
        this.toastr.error(
          'Input XML API configuration is not available for selected deployment',
          '',
          {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          }
        );
        return null;
      }

      const obj = {
        Accessionnumber: accession,
        EntityType: this.mapGqrEntityTypeForApi(this.gqrEntityTypeName),
        EntityValue: this.gqrEntityLocationGUID,
        MessageType: this.normalizeGqrMessageType(this.selectedmessagetype),
        Headers: JSON.stringify(dpconfig.apidetails['headers']),
        Url: dpconfig.apidetails['inputxmlapiurl'],
      };

      const dxresponse: any = await this.service.postapi(
        'api/TransformXml/GetInputXML',
        obj
      );

      if (!dxresponse || !dxresponse['responsemessage']) {
        this.toastr.warning('No data found', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return null;
      }
      if (!dxresponse['xml'] && dxresponse['responsemessage']) {
        this.toastr.warning(dxresponse['responsemessage'], '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return null;
      }
      if (dxresponse['responsemessage'] && dxresponse['xml']) {
        return dxresponse['xml'];
      }

      this.toastr.warning('No data found', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return null;
    } catch {
      this.toastr.error('Unable to fetch XML for accession number', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return null;
    } finally {
      this.ngxUiLoaderService.stop();
    }
  }

  /** Fetches XML by accession + entity and loads it into the input editor. */
  async getGqrInputXml(): Promise<void> {
    const accession = (this.gqrSearchkey || '').trim();
    if (!accession) {
      this.toastr.warning('Please enter the accession number', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (accession.indexOf(',') > -1) {
      this.toastr.warning('Multiple Accession Search is not supported!', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    const fetchedXml = await this.getGqrCaseXml();
    if (fetchedXml) {
      this.inputdataGqr = fetchedXml;
    }
  }

  getQualifiedRoutes() {
    this.qualifiedRoutesList = [];

    if (!this.deploymentSelected) {
      this.toastr.warning("Deploymentkey is required", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    if (!this.selectedmessagetype) {
      this.toastr.warning('Message Type is required', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    if (!this.selectedAgentguid) {
      this.toastr.warning('Unable to get sourceagent', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    const xmlInput = (this.inputdataGqr || '').toString().trim();
    if (!xmlInput) {
      this.toastr.warning('Input XML is required', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    if (!this.isValidXML(xmlInput)) {
      this.toastr.error('Input should be in XML format', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    const requestBody = {
      xml: xmlInput,
      sourceagent: this.selectedAgentguid,
      messagetype: this.selectedmessagetype,
    };

    this.ngxUiLoaderService.start();

    this.service.GetQualifiedRoutesForXML(requestBody).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop();

        if (response && response.responsebody != null && response.responsebody != '[]') {
          try {
            const qualifiedRoutes = JSON.parse(response.responsebody);
            this.qualifiedRoutesList = qualifiedRoutes.map((route: any) => ({
              id: route.id,
              displayname: route.displayname
            }));

            this.toastr.success("Qualified routes fetched successfully", "", {
              timeOut: 500,
              positionClass: 'toast-bottom-right'
            });
          } catch (error) {
            this.toastr.error("Error parsing response body", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        } else {
          this.toastr.error("No routes found for the given input", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      },
      error: (error) => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Error fetching qualified routes", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }
  //Deployment selection
  selectdeploymentEvent(item: any) {
    this.deploymentSelected = item;
    this.getAgentByDeploymentAndDirection();
  }
   onFocuseddeployment(event) {
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  cleareddeployment(event) {
    this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  getDeployments() {
    this.service.getDeployments("Deployments").subscribe(
      (data) => {
        if (data.length > 0) {
          this.deploymentItemsList = data;
        } else if (data.length === 0) {
          this.deploymentItemsList = [];
        }
      },
      (error) => {
        this.toastr.error("Something went wrong", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }

  getAgentByDeploymentAndDirection(): void {
    if (!this.deploymentSelected) {
      return; 
    }

    const direction = 'Outbound'; 

    
    this.service.GetAgentByDirectionAndDeployment(direction,this.deploymentSelected, ).subscribe({
      next: (response: any[]) => {
        if (response && Array.isArray(response) && response.length > 0) {
          
          this.selectedAgentguid = response[0].id;
        } else {
          this.selectedAgentguid = '';
        }
      },
      error: () => {
       
        this.selectedAgentguid = '';
      }
    });
  }

  locationString(item: string, item1: string, item2: string) {
    const names = item2.split('(');
    item2 = names[2] !== 'null)' && names[2] !== undefined
      ? `${names[0]} <br> (${names[1]} <br> (${names[2]}`
      : `${names[0]} <br> (${names[1]}`;
    return '(' + item + ')' + ' ' + item1 + ' : ' + item2;
  }

  // ---------- Search Builder: Lab / Facility entity autocomplete (GetAccountNames) ----------

  /** Normalizes colon spacing in entity search text (same as Interface source/target search). */
  private normalizeEntitySearchInput(event: string): string {
    let value = event;
    if (value.includes(':')) {
      const splitValues = value.split(':');
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = ' ' + splitValues[1];
        value = splitValues.join(':');
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = ' ' + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = ' ' + splitValues[2];
        value = splitValues.join(':');
      }
    }
    return value;
  }

  /** Called when user picks a Lab from the autocomplete dropdown. */
  selectedSearchBuilderLab(item: any) {
    this.applySearchBuilderLabSelection(item);
  }

  /** Stores lab GUID, deployment, associated accounts, and entity type from autocomplete selection. */
  private applySearchBuilderLabSelection(item: any): void {
    if (!item) {
      return;
    }
    this.sbLabLocationGUID = item.LocationGUID || '';
    this.sbLabDeploymentKey = item.deploymentkey || '';
    this.sbLabAssociatedAccountIds = item.associatedaccountids || '';
    this.sbLabTypeName = this.resolveEntityTypeName(item.TypeName, item.Type);
  }

  /** Derives Organization vs Account from entity TypeName or Type code (O, A, E-O, E-A). */
  private resolveEntityTypeName(typeName: string, type: string): string {
    if (typeName) {
      return typeName;
    }
    if (type === 'O' || type === 'E-O') {
      return 'Organization';
    }
    if (type === 'A' || type === 'E-A') {
      return 'Account';
    }
    return '';
  }

  /** Pulls the first GUID substring from lab/facility input text, or empty if none. */
  private extractGuidFromText(value: string): string {
    if (!value) {
      return '';
    }
    const match = GUID_PATTERN.exec(value);
    return match ? match[0] : '';
  }

  /** Server-driven entity lists: show all API results without client-side re-filtering. */
  searchBuilderEntityCustomFilter = (items: any[]) => items || [];

  /** Builds GetAccountNames request; includes related entity context only when lab/facility already selected. */
  private buildSearchBuilderEntitySearchRequest(
    searchText: string,
    target: 'lab' | 'facility'
  ): Record<string, string> {
    const request: Record<string, string> = {
      lsearch: searchText,
      lSearch: searchText
    };
    if (target === 'lab' && this.sbFacilityLocationGUID) {
      request.LocationGUID = this.sbFacilityLocationGUID;
      request.deploymentkey = this.sbFacilityDeploymentKey || '';
      request.associatedaccountids = this.sbFacilityAssociatedAccountIds || '';
    } else if (target === 'facility' && this.sbLabLocationGUID) {
      request.LocationGUID = this.sbLabLocationGUID;
      request.deploymentkey = this.sbLabDeploymentKey || '';
      request.associatedaccountids = this.sbLabAssociatedAccountIds || '';
    }
    return request;
  }

  /** Finds best entity match in API results by LocationGUID, orgguid, org type, or single result. */
  private findSearchBuilderEntityMatch(list: any[], guid: string): any | null {
    if (!list?.length || !guid) {
      return null;
    }
    const g = guid.toLowerCase();

    const byLocationGuid = list.find((item: any) =>
      (item.LocationGUID || '').toLowerCase() === g);
    if (byLocationGuid) {
      return byLocationGuid;
    }

    const byOrgGuid = list.find((item: any) =>
      (item.orgguid || '').toLowerCase() === g);
    if (byOrgGuid) {
      return byOrgGuid;
    }

    const orgType = list.find((item: any) =>
      item.Type === 'O' || item.Type === 'E-O' || item.TypeName === 'Organization');
    if (orgType) {
      return orgType;
    }

    return list.length === 1 ? list[0] : null;
  }

  /** Sorts entities alphabetically and appends GUID/VA-ID to LocationName for dropdown display. */
  private formatSearchBuilderEntityList(response: any[]): any[] {
    const list = this.service.transformAlphabetically(response, 'LocationName');
    list.forEach((obj: any) => {
      obj.LocationName = obj.UniqueID != null && obj.UniqueID !== undefined
        ? `${obj.LocationName} (${obj.LocationGUID}) (${obj.UniqueID})`
        : `${obj.LocationName} (${obj.LocationGUID})`;
    });
    return list;
  }

  /** After GUID search: fills input with entity name and sets lab/facility context without breaking org-level GUID. */
  private applySearchBuilderEntityGuidDisplay(
    match: any,
    typedGuid: string,
    list: any[],
    target: 'lab' | 'facility'
  ): void {
    const g = typedGuid.toLowerCase();
    const isLab = target === 'lab';
    const formGroup = isLab ? this.reactiveFormSbLab : this.reactiveFormSbFacility;
    const formControl = isLab ? 'labname' : 'facilityname';
    const locationGuid = (match.LocationGUID || '').toLowerCase();
    const isOrgRecord = match.Type === 'O' || match.Type === 'E-O' || match.TypeName === 'Organization';
    const isDirectGuidMatch = locationGuid === g;

    if (isDirectGuidMatch) {
      if (isLab) {
        this.applySearchBuilderLabSelection(match);
      } else {
        this.selectedSearchBuilderFacility(match);
      }
      formGroup.patchValue({ [formControl]: match.LocationName }, { emitEvent: false });
      return;
    }

    if (isLab) {
      this.sbLabLocationGUID = typedGuid;
      this.sbLabTypeName = 'Organization';
      if (match.deploymentkey) {
        this.sbLabDeploymentKey = match.deploymentkey;
      }
      if (match.associatedaccountids) {
        this.sbLabAssociatedAccountIds = match.associatedaccountids;
      }
    } else {
      this.sbFacilityLocationGUID = typedGuid;
      this.sbFacilityTypeName = 'Organization';
      if (match.deploymentkey) {
        this.sbFacilityDeploymentKey = match.deploymentkey;
      }
      if (match.associatedaccountids) {
        this.sbFacilityAssociatedAccountIds = match.associatedaccountids;
      }
    }

    if (list.length === 1 || isOrgRecord) {
      formGroup.patchValue({ [formControl]: match.LocationName }, { emitEvent: false });
    }
  }

  /** Calls GetAccountNames for lab/facility autocomplete; falls back to GET lookup when GUID search returns empty. */
  private fetchSearchBuilderEntityNames(
    searchText: string,
    target: 'lab' | 'facility',
    typedGuid: string,
    onComplete: () => void
  ): void {
    const request = this.buildSearchBuilderEntitySearchRequest(searchText, target);
    this.service.GetAccountNamesListAsync(request).subscribe((response: any) => {
      const hasResults = Array.isArray(response) && response.length > 0;
      if (!hasResults && typedGuid) {
        this.service.getEntityfilterdata(typedGuid).subscribe({
          next: (fallback: any) => {
            this.handleSearchBuilderEntityResponse(fallback, target, onComplete, typedGuid);
          },
          error: () => {
            this.handleSearchBuilderEntityResponse(response, target, onComplete, typedGuid);
          }
        });
        return;
      }
      this.handleSearchBuilderEntityResponse(response, target, onComplete, typedGuid);
    });
  }

  /** Before Search: ensures lab deployment/type/GUID are resolved from dropdown or API when user pasted a GUID. */
  private async resolveSearchBuilderLabContextBeforeSearch(): Promise<void> {
    const labText = (this.reactiveFormSbLab.get('labname')?.value || '').toString();
    const guid = this.extractGuidFromText(labText);

    if (!guid || (this.sbLabTypeName && this.sbLabDeploymentKey)) {
      return;
    }

    const fromList = this.findSearchBuilderEntityMatch(this.searchBuilderLabList, guid);
    if (fromList) {
      this.applySearchBuilderLabSelection(fromList);
      return;
    }

    await new Promise<void>((resolve) => {
      this.service.GetAccountNamesListAsync({ lsearch: guid, lSearch: guid }).subscribe({
        next: (response: any) => {
          if (!response?.status && !response?.statusText) {
            const results = response || [];
            const exact = this.findSearchBuilderEntityMatch(results, guid);
            if (exact) {
              this.applySearchBuilderLabSelection(exact);
              const formatted = this.formatSearchBuilderEntityList([exact])[0];
              this.reactiveFormSbLab.patchValue(
                { labname: formatted?.LocationName || exact.LocationName },
                { emitEvent: false }
              );
            }
          }
          resolve();
        },
        error: () => resolve()
      });
    });
  }

  /** Clears lab autocomplete state, GUID context, and source agent when user clears the Lab field. */
  searchBuilderLabCleared() {
    this.isLoadingSbLab = false;
    this.searchBuilderLabList = [];
    this.sbLabLocationGUID = '';
    this.sbLabDeploymentKey = '';
    this.sbLabAssociatedAccountIds = '';
    this.sbLabTypeName = '';
    this.notfounddataSbLab = false;
  }

  /** Lab autocomplete inputChanged handler — debounced entity search via GetAccountNames. */
  getSearchBuilderLabNames(event: string) {
    const valuesa = this.normalizeEntitySearchInput(event);
    const typedGuid = this.extractGuidFromText(event);
    this.sbLabDeploymentKey = '';
    this.sbLabAssociatedAccountIds = '';
    this.sbLabTypeName = '';
    this.sbLabLocationGUID = typedGuid || '';
    this.reactiveFormSbLab.patchValue({ labname: event });
    if (valuesa !== '' && !valuesa.endsWith(':') && !valuesa.endsWith(': ')) {
      const valueToSendToApi = valuesa.split(': ').join(':');
      this.isLoadingSbLab = true;
      this.fetchSearchBuilderEntityNames(valueToSendToApi, 'lab', typedGuid, () => {
        this.isLoadingSbLab = false;
      });
    } else {
      this.searchBuilderLabList = [];
      this.notfounddataSbLab = !typedGuid;
    }
  }

  /** Called when user picks a Facility from the autocomplete dropdown. */
  selectedSearchBuilderFacility(item: any) {
    this.sbFacilityLocationGUID = item.LocationGUID;
    this.sbFacilityDeploymentKey = item.deploymentkey;
    this.sbFacilityAssociatedAccountIds = item.associatedaccountids;
    this.sbFacilityTypeName = item.TypeName;
  }

  /** Clears facility autocomplete state and GUID context when user clears the Facility field. */
  searchBuilderFacilityCleared() {
    this.isLoadingSbFacility = false;
    this.searchBuilderFacilityList = [];
    this.sbFacilityLocationGUID = '';
    this.sbFacilityDeploymentKey = '';
    this.sbFacilityAssociatedAccountIds = '';
    this.sbFacilityTypeName = '';
    this.notfounddataSbFacility = false;
  }

  /** Facility autocomplete inputChanged handler — debounced entity search via GetAccountNames. */
  getSearchBuilderFacilityNames(event: string) {
    const valueta = this.normalizeEntitySearchInput(event);
    const typedGuid = this.extractGuidFromText(event);
    if (!typedGuid) {
      this.sbFacilityLocationGUID = '';
      this.sbFacilityDeploymentKey = '';
      this.sbFacilityAssociatedAccountIds = '';
      this.sbFacilityTypeName = '';
    } else {
      this.sbFacilityLocationGUID = typedGuid;
    }
    this.reactiveFormSbFacility.patchValue({ facilityname: event });
    if (valueta !== '' && !valueta.endsWith(':') && !valueta.endsWith(': ')) {
      const valueToSendToApi = valueta.split(': ').join(':');
      this.isLoadingSbFacility = true;
      this.fetchSearchBuilderEntityNames(valueToSendToApi, 'facility', typedGuid, () => {
        this.isLoadingSbFacility = false;
      });
    } else {
      this.searchBuilderFacilityList = [];
      this.notfounddataSbFacility = !typedGuid;
    }
  }

  /** Maps GetAccountNames API response into lab/facility dropdown list; handles GUID display and not-found state. */
  private handleSearchBuilderEntityResponse(
    response: any,
    target: 'lab' | 'facility',
    onComplete: () => void,
    typedGuid = ''
  ) {
    const isLab = target === 'lab';
    const listProp = isLab ? 'searchBuilderLabList' : 'searchBuilderFacilityList';
    const notFoundProp = isLab ? 'notfounddataSbLab' : 'notfounddataSbFacility';

    if (response?.status && response?.statusText) {
      this[listProp] = [];
      this[notFoundProp] = !typedGuid;
      onComplete();
      this.toastr.error(`Unable to fetch ${target} details`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    if (Array.isArray(response) && response.length > 0) {
      const list = this.formatSearchBuilderEntityList(response);
      this[listProp] = list;
      this[notFoundProp] = false;

      if (typedGuid) {
        const match = this.findSearchBuilderEntityMatch(list, typedGuid);
        if (match) {
          this.applySearchBuilderEntityGuidDisplay(match, typedGuid, list, target);
        }
      }
    } else {
      this[listProp] = [];
      this[notFoundProp] = !typedGuid;
    }
    onComplete();
  }

  /** Stores selected message type from Search Builder message type autocomplete. */
  selectedSearchBuilderMessageType(item: any) {
    this.searchBuilderMessageType = item.displayname;
  }

  /** Clears message type filter and restores full message type list. */
  clearSearchBuilderMessageType() {
    this.searchBuilderMessageType = '';
    this.messageTypeList = this.messageTypeAllList?.length ? this.messageTypeAllList : [];
  }

  // ---------- Search Builder: route search (GetQualifiedRoute) and results ----------

  /** Search button handler — validates lab, resolves entity context, then calls GetQualifiedRoute API. */
  onSearchBuilderSearch() {
    const labText = (this.reactiveFormSbLab.get('labname')?.value || '').toString().trim();
    if (!labText && !this.sbLabLocationGUID) {
      this.toastr.warning('Lab is required', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    if (!this.isSearchBuilderAdvancedFilterValid()) {
      this.toastr.warning('Please complete Field, Operator, and Value for advanced filter row', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    this.ngxUiLoaderService.start();
    this.resolveSearchBuilderLabContextBeforeSearch()
      .then(() => this.executeSearchBuilderSearch(labText))
      .catch(() => this.ngxUiLoaderService.stop());
  }

  /** Builds GetQualifiedRoute request from lab/facility context and posts to RuleEngineReports API. */
  private executeSearchBuilderSearch(labText: string) {
    const facilityText = (this.reactiveFormSbFacility.get('facilityname')?.value || '').toString().trim();
    const guidFromText = this.extractGuidFromText(labText);
    const requestBody: Parameters<CommonService['GetQualifiedRuleEngineRoutes']>[0] = {
      messageType: this.searchBuilderMessageType || '',
      labLSearch: guidFromText || labText.split(': ').join(':'),
      labLocationGUID: this.sbLabLocationGUID || guidFromText,
      labDeploymentKey: this.sbLabDeploymentKey,
      labAssociatedAccountIds: this.sbLabAssociatedAccountIds,
      labTypeName: this.sbLabTypeName,
      facilityLSearch: facilityText ? facilityText.split(': ').join(':') : '',
      facilityLocationGUID: this.sbFacilityLocationGUID,
      facilityDeploymentKey: this.sbFacilityDeploymentKey,
      facilityAssociatedAccountIds: this.sbFacilityAssociatedAccountIds,
      facilityTypeName: this.sbFacilityTypeName,
      includePassiveRoutesAlso: this.searchBuilderIncludePassiveRoutes
    };

    const advancedRules = this.getActiveSearchBuilderAdvancedRules();
    this.searchBuilderLastSearchUsedAdvancedRules = advancedRules.length > 0;
    if (advancedRules.length > 0) {
      requestBody.applyAdvancedRules = true;
      requestBody.advancedRules = advancedRules.map((r) => ({
        field: r.field.trim(),
        operator: r.operator,
        value: r.value
      }));
    }

    this.searchBuilderSearched = true;
    this.service.GetQualifiedRuleEngineRoutes(requestBody).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop();
        if (response?.status === 'success' && response?.responsebody) {
          try {
            const routes = JSON.parse(response.responsebody);
            this.searchBuilderRoutesListAll = this.mapSearchBuilderRoutes(routes);
            this.applySearchBuilderPagination(true);
            if (this.searchBuilderRoutesListAll.length === 0) {
              const emptyMsg = advancedRules.length > 0
                ? 'No routes match the advanced rule criteria.'
                : 'No rule engine routes found';
              this.toastr.error(emptyMsg, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            } else {
              this.toastr.success('Routes fetched successfully', '', {
                timeOut: 500,
                positionClass: 'toast-bottom-right'
              });
            }
          } catch {
            this.searchBuilderRoutesListAll = [];
            this.searchBuilderRoutesList = [];
            this.searchBuilderTotalRecords = 0;
            this.toastr.error('Error parsing response', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        } else {
          this.searchBuilderRoutesListAll = [];
          this.searchBuilderRoutesList = [];
          this.searchBuilderTotalRecords = 0;
          this.toastr.error(response?.statusmessage || 'Failed to fetch routes', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      },
      error: () => {
        this.ngxUiLoaderService.stop();
        this.searchBuilderRoutesListAll = [];
        this.searchBuilderRoutesList = [];
        this.searchBuilderTotalRecords = 0;
        this.toastr.error('Error fetching routes', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }

  /** Resets all Search Builder filters, results, pagination, and advanced rules. */
  clearSearchBuilder() {
    this.reactiveFormSbLab.reset();
    this.reactiveFormSbFacility.reset();
    this.reactiveFormSbMsgtype.reset();
    this.searchBuilderLabCleared();
    this.searchBuilderFacilityCleared();
    this.clearSearchBuilderMessageType();
    this.searchBuilderRoutesListAll = [];
    this.searchBuilderRoutesList = [];
    this.searchBuilderTotalRecords = 0;
    this.searchBuilderPageNumber = 1;
    this.searchBuilderIncludePassiveRoutes = false;
    this.searchBuilderSearched = false;
    this.searchBuilderLastSearchUsedAdvancedRules = false;
    this.showSearchBuilderAdvancedFilter = false;
    this.clearSearchBuilderAdvancedRules();
    if (this.searchBuilderPaginator) {
      this.searchBuilderPaginator.firstPage();
    }
  }

  /** Same pagination pattern as Interface screen (15 per page). */
  getSearchBuilderPageDetails(event: { pageIndex: number; pageSize: number }): void {
    this.searchBuilderPageNumber = event.pageIndex === 0 ? 1 : event.pageIndex + 1;
    this.searchBuilderPageSize = 15;
    this.applySearchBuilderPagination(false);
  }

  /** Maps API pipeline DTOs to SearchBuilderRouteItem for the results grid. */
  private mapSearchBuilderRoutes(routes: any[]): SearchBuilderRouteItem[] {
    return (routes || []).map((route: any) => ({
      id: route.id,
      displayname: route.displayname,
      vendorName: route.vendorName ?? route.vendor,
      vendorId: route.vendorId ?? route.vendorid,
      sourceEntityId: route.sourceEntityId,
      sourceEntityName: route.sourceEntityName ?? route.SENAME,
      destinationEntityId: route.destinationEntityId,
      destinationEntityName: route.destinationEntityName ?? route.DENAME,
      messageType: route.messageType,
      status: route.status || 'active',
      processorId: route.processorId,
      processorName: route.processorName,
      uniqueId: route.uniqueId ?? route.UniqueID ?? route.uniqueID,
      version: route.version ?? route.Version,
      setype: route.setype ?? route.SETYPE,
      detype: route.detype ?? route.DETYPE,
      ruleMatchStatus: route.ruleMatchStatus ?? route.RuleMatchStatus
    }));
  }

  /** Column header: "Route Status" or "Rule Match Status" depending on whether advanced rules were used. */
  getSearchBuilderStatusLabel(): string {
    return this.searchBuilderLastSearchUsedAdvancedRules
      ? 'Rule Match Status'
      : 'Route Status';
  }

  /** Status cell value: route status (active/passive) or advanced rule match status. */
  getSearchBuilderStatusValue(route: SearchBuilderRouteItem): string {
    if (this.searchBuilderLastSearchUsedAdvancedRules) {
      return route.ruleMatchStatus || '—';
    }

    const status = (route.status || '').toString().trim();
    return status ? status.charAt(0).toUpperCase() + status.slice(1) : '—';
  }

  /** Exports all Search Builder route results to an Excel file (client-side xlsx). */
  exportSearchBuilderResults(): void {
    if (!this.searchBuilderRoutesListAll?.length) {
      return;
    }

    const selectedItems = this.searchBuilderRoutesListAll.map((route) => ({
      'Pipeline Name': route.displayname,
      'Pipeline GUID': route.id,
      'Vendor': route.vendorName,
      'Source Entity': route.sourceEntityName,
      'Source Entity GUID': route.sourceEntityId,
      'Processor': route.processorName,
      'Processor GUID': route.processorId,
      'Target Entity': route.destinationEntityName,
      'Target Entity GUID': route.destinationEntityId,
      'Message Type': route.messageType,
      [this.getSearchBuilderStatusLabel()]: this.getSearchBuilderStatusValue(route)
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(selectedItems);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: 'application/xml' });
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'RuleEngineSearchBuilderRoutes.xlsx';
    link.click();
  }

  /** Slices searchBuilderRoutesListAll into the current page for the results grid. */
  private applySearchBuilderPagination(resetToFirstPage = false): void {
    if (resetToFirstPage) {
      this.searchBuilderPageNumber = 1;
    }

    this.searchBuilderTotalRecords = this.searchBuilderRoutesListAll.length;
    const start = (this.searchBuilderPageNumber - 1) * this.searchBuilderPageSize;
    this.searchBuilderRoutesList = this.searchBuilderRoutesListAll.slice(
      start,
      start + this.searchBuilderPageSize
    );

    setTimeout(() => {
      if (this.searchBuilderPaginator) {
        this.searchBuilderPaginator.length = this.searchBuilderTotalRecords;
        if (resetToFirstPage) {
          this.searchBuilderPaginator.firstPage();
        }
      }
    });
  }

  /** Same as Interface editPipeline — opens Create Page for Version 2 routes. */
  searchBuilderEditPipeline(route: {
    id: string;
    displayname: string;
    version?: string;
  }): void {
    if (route?.version === '2' || !route?.version) {
      sessionStorage.setItem('pipelineid', JSON.stringify(route.id));
      this.service.setPipelineName(
        JSON.stringify({ id: route.id, name: route.displayname })
      );
      return;
    }

    const routeVersionModalRef = this.modalService.open(Routeversion1Component, {
      windowClass: 'myCustomModalClass',
      backdrop: 'static',
      keyboard: false
    });
    routeVersionModalRef.componentInstance.inputDataInModalComponent = route;
  }

  /** Same as Create Page Rule button — opens Pipeline Rules dialog (dialog loads versions from API). */
  onSearchBuilderRouteRowClick(route: {
    id: string;
    displayname: string;
    uniqueId?: number;
    sourceEntityId?: string;
    destinationEntityId?: string;
    setype?: string;
    detype?: string;
  }): void {
    this.resolveSearchBuilderUniqueId(route).then((uniqueId) => {
      if (!uniqueId) {
        this.toastr.error('Unable to open pipeline rules for this route.', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return;
      }

      this.dialog.open(RuleConfigComponentComponent, {
        maxWidth: '95vw',
        height: '96%',
        width: '100%',
        viewContainerRef: this.viewContainerRef,
        data: {
          data: this.buildSearchBuilderRuleConfigRequest(route),
          isView: false,
          routeGuid: route.id,
          routeName: route.displayname,
          routeUniqueID: uniqueId,
          ruleExecutionStage: 'Validation',
          componentname: 'createpipeline',
          dialogTitle: 'Pipeline Rules'
        },
        autoFocus: false,
        disableClose: true,
        panelClass: 'rule-config-dialog-container'
      });
    });
  }

  /** Fetches route UniqueID from API when missing (required to open Pipeline Rules dialog). */
  private resolveSearchBuilderUniqueId(route: {
    id: string;
    uniqueId?: number;
  }): Promise<number> {
    const existing = Number(route?.uniqueId ?? 0);
    if (existing > 0) {
      return Promise.resolve(existing);
    }

    return new Promise((resolve) => {
      this.service
        .getapiurl(`api/Routes/GetRouteList?id=${encodeURIComponent(route.id)}`)
        .subscribe({
          next: (data: any) => {
            const resolved = Number(data?.UniqueID ?? data?.uniqueID ?? data?.uniqueId ?? 0);
            if (resolved > 0) {
              route.uniqueId = resolved;
            }
            resolve(resolved);
          },
          error: () => resolve(0)
        });
    });
  }

  /** Builds SE/DE entity payload for RuleConfigComponent when opening Pipeline Rules from a route row. */
  private buildSearchBuilderRuleConfigRequest(route: {
    sourceEntityId?: string;
    destinationEntityId?: string;
    setype?: string;
    detype?: string;
  }): any[] {
    const request: any[] = [
      {
        Type: 'SE',
        EntityType: route.setype || 'Account',
        TypeName: route.setype || 'Account',
        Guid: route.sourceEntityId
      }
    ];
    if (
      route.sourceEntityId &&
      route.destinationEntityId &&
      route.sourceEntityId !== route.destinationEntityId
    ) {
      request.push({
        Type: 'DE',
        EntityType: route.detype || 'Account',
        TypeName: route.detype || 'Account',
        Guid: route.destinationEntityId
      });
    }
    return request;
  }

  /** True when any Search Builder filter or results exist — used to confirm before leaving tab. */
  hasInputForSearchBuilder(): boolean {
    const lab = (this.reactiveFormSbLab?.get('labname')?.value || '').toString().trim();
    const facility = (this.reactiveFormSbFacility?.get('facilityname')?.value || '').toString().trim();
    return !!(
      lab ||
      facility ||
      this.searchBuilderMessageType ||
      this.searchBuilderIncludePassiveRoutes ||
      this.hasSearchBuilderAdvancedRuleInput() ||
      this.searchBuilderRoutesListAll.length
    );
  }

  /** True when any advanced rule row has field or value text entered. */
  private hasSearchBuilderAdvancedRuleInput(): boolean {
    return this.searchBuilderAdvancedRules.some((rule) =>
      !!((rule.field || '').trim() || (rule.operator || '').trim() || (rule.value ?? '').length > 0)
    );
  }
}